module.exports = __webpack_public_path__ + "static/media/hello.49767f2a.JPG";